export const SEARCH_FILTER_DATA_TYPES: {
  jobs: "JOBS";
  talent: "TALENT";
  bids: "BIDS";
} = {
  jobs: "JOBS",
  talent: "TALENT",
  bids: "BIDS",
};
